import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import LogentryForm from '../ui/LogentryForm'
import LogentryModel from '../model/LogentryModel'
import ObjectTypeMapping from '../../constants/ObjectTypeMapping'

export default class EditLogentry {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.logentryForm.getValue()
      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('logentries', this.data.getJSON()).then((logentry) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }

        if (args && !args.id && logentry.id) {
          window.PRIM.navigate('/logentries/' + logentry.id, true)
        }

        if (logentry) {
          this.data.values.id = logentry.id
          this.logentryForm.setValue(this.data)
        }        
      })
    }

    this.data = new LogentryModel()

    if (args) {
      if (args.id) {
        window.PRIM.dataAccess.resolve('logentries', args.id, false).then((logentry) => {
          this.data = logentry
          this.logentryForm.setValue(this.data)
        }, () => {
          if (confirm('Deze logregel bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw logregel aanmaken?')) {
            window.PRIM.navigate('/logentries/')
          } else {
            history.back()
          }
        }).catch(() => {
        })
      } else if (args.target_id && args.object_type) {
        this.data.values.target_id = args.target_id
        this.data.values.object_type_id = ObjectTypeMapping[args.object_type]

        let now = new Date()
        now = new Date(now.getTime() - now.getTimezoneOffset() * 60000)

        this.data.values.timestamp = now.toISOString().substring(0, 19).replace('T', ' ')
      }
    } else {
      let now = new Date()
      now = new Date(now.getTime() - now.getTimezoneOffset() * 60000)

      this.data.values.timestamp = now.toISOString().substring(0, 19).replace('T', ' ')
    }

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Logregel bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u deze logregel wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('logentries', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor deze logregel.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    this.logentryForm = new LogentryForm(divContent, {logentry: this.data, onchange: this.onchange})

    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/logentry/action/EditLogentry.js